<template>
  <div class="store-map-page">
    <!-- 顶部按钮选择 -->
    <div class="store-selector">
      <el-button
        v-for="(store, key) in storeMap"
        :key="key"
        :class="['store-btn', selectedKey === key ? 'active' : '']"
        @click="switchStore(key)"
      >
        {{ store.name }}
      </el-button>
    </div>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 左侧地图 -->
      <div class="map-box">
        <iframe
          class="map-frame"
          :src="mapEmbedUrl"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          allowfullscreen
        ></iframe>
      </div>

      <!-- 右侧信息 -->
      <div class="info-box">
        <template v-if="currentStore.type === 'upcoming'">
          <div class="upcoming-store-list">
            <button
              v-for="store in upcomingStores"
              :key="store.key"
              :class="[
                'upcoming-store-card',
                selectedUpcomingKey === store.key ? 'active' : '',
              ]"
              type="button"
              @click="switchUpcomingStore(store.key)"
            >
              <strong>{{ store.name }}</strong>
              <span>{{ store.openingTime }}</span>
            </button>
          </div>
        </template>

        <template v-else>
          <h2>{{ currentStore.name }}</h2>

          <div class="info-item">
            <img src="@/assets/images/位置.png" class="icon" alt="位置" />
            <span>{{ currentStore.address }}</span>
          </div>

          <div class="info-item">
            <img src="@/assets/images/时间.png" class="icon" alt="营业时间" />
            <span>{{ currentStore.openTime }}</span>
          </div>

          <div class="info-item">
            <img src="@/assets/images/电话.png" class="icon" alt="电话" />
            <span>{{ currentStore.phone }}</span>
          </div>

          <div class="info-item">
            <img src="@/assets/images/邮箱.png" class="icon" alt="邮箱" />
            <span>{{ currentStore.email }}</span>
          </div>

          <div class="info-item">
            <img src="@/assets/images/Whatapp .png" class="icon" alt="Whatsapp" />
            <span>{{ currentStore.Whatapp }}</span>
          </div>
        </template>

        <!-- 引导用户前往 Google 地图评价 -->
        <div class="info-item review-tip">
          <img class="icon" src="@/assets/images/zan.png" alt="review icon" />
          <span class="review-text">{{ $t('offlineStore.reviewTip') }}</span>
          <a
            class="review-link"
            :href="mapTarget.reviewLink || mapTarget.link"
            target="_blank"
            rel="noopener"
          >{{ $t('offlineStore.reviewAction') }}</a>
        </div>

        <!-- 📢 社交媒体跳转图标区域 -->
        <div class="social-icons">
          <a
            v-if="currentStore.socialLinks.facebook"
            :href="currentStore.socialLinks.facebook"
            target="_blank"
          >
            <img src="@/assets/images/facebook.png" alt="Facebook" />
          </a>
          <a
            v-if="currentStore.socialLinks.ig"
            :href="currentStore.socialLinks.ig"
            target="_blank"
          >
            <img src="@/assets/images/IG.png" alt="Instagram" />
          </a>
          <a
            v-if="currentStore.socialLinks.tiktok"
            :href="currentStore.socialLinks.tiktok"
            target="_blank"
          >
            <img src="@/assets/images/tiktok.png" alt="TikTok" />
          </a>
          <a
            v-if="currentStore.socialLinks.whatsapp"
            :href="currentStore.socialLinks.whatsapp"
            target="_blank"
          >
            <img src="@/assets/images/what.png" alt="WhatsApp" />
          </a>
        </div>

        <div class="info-actions">
          <el-button class="go-btn" @click="goToMap" round>
            🚗 {{ $t("offlineStore.navigateBtn") }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- PC端展示：图网格+弹窗 -->
    <div v-if="!isMobile && selectedKey === 'store1'" class="store-images">
      <h3 class="store-image-title">
        <span class="yellow">/ Store Images</span>
      </h3>
      <div class="image-grid">
        <img
          v-for="i in 9"
          :key="i"
          :src="require(`@/assets/images/storeimages/pvbj/${i}.jpg`)"
          alt="门店图片"
          class="store-image"
          @click="
            showImageDialog(
              require(`@/assets/images/storeimages/pvbj/${i}.jpg`)
            )
          "
        />
      </div>
    </div>

    <div v-if="!isMobile && selectedKey === 'store2'" class="store-images">
      <h3 class="store-image-title">
        <span class="yellow">/ Store Images</span>
      </h3>
      <div class="image-grid">
        <img
          v-for="i in 9"
          :key="i"
          :src="require(`@/assets/images/storeimages/sv/${i}.jpg`)"
          alt="门店图片"
          class="store-image"
          @click="
            showImageDialog(require(`@/assets/images/storeimages/sv/${i}.jpg`))
          "
        />
      </div>
    </div>

    <!-- 移动端轮播展示 -->
    <div v-if="isMobile && currentStore.imageDir" class="store-images-mobile">
      <h3 class="store-image-title">
        /<span class="yellow">Store Images</span>
      </h3>
      <swiper
        :modules="[Autoplay]"
        :space-between="12"
        :slides-per-view="1"
        :loop="true"
        :autoplay="{ delay: 3000, disableOnInteraction: false }"
      >
        <swiper-slide v-for="i in 9" :key="i">
          <img
            class="mobile-store-image"
            :src="require(`@/assets/images/storeimages/${currentStore.imageDir}/${i}.jpg`)"
            alt="门店大图"
          />
        </swiper-slide>
      </swiper>
    </div>

    <!-- 弹窗大图仅PC端保留 -->
    <div
      v-if="previewVisible && !isMobile"
      class="dialog-mask"
      @click.self="closeImageDialog"
    >
      <div class="dialog image-dialog">
        <div class="dialog-header">
          <span>{{ $t("offlineStore.real") }}</span>
          <span class="close-btn" @click="closeImageDialog">&times;</span>
        </div>
        <div class="dialog-body image-dialog-body">
          <img :src="previewImage" alt="门店预览图" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const { locale } = useI18n();
const isZh = computed(() => locale.value === "zh");
const commonSocialLinks = {
  facebook: "https://www.facebook.com/share/16UZ5ywBbH/",
  tiktok: "https://www.tiktok.com/@cabbeen.pvbj",
  ig: "https://www.instagram.com/cabbeen.pvbj/",
};
const upcomingSocialLinks = {
  facebook: "https://www.facebook.com/profile.php?id=61573840030138",
  tiktok: "https://www.tiktok.com/@cabbeen.my",
  ig: "https://www.instagram.com/cabbeen.my/",
  whatsapp: "https://www.whatsapp.com/channel/0029VbATZrZEawdjq9UsEJ03",
};
const midValleySocialLinks = {
  facebook: "https://www.facebook.com/profile.php?id=61591553318463",
  tiktok: "https://www.tiktok.com/@cabbeen.my",
  ig: "https://www.instagram.com/cabbeen.midvalley/",
};

const upcomingStores = computed(() => [
  {
    key: "118mall",
    name: "CABBEEN - 118 Mall",
    type: "upcoming",
    lat: 3.14167,
    lng: 101.70036,
    address: "merdeak 118",
    mapQuery: "merdeak 118",
    link: "https://maps.google.com/?q=merdeak+118",
    reviewLink: "https://maps.google.com/?q=merdeak+118",
    openingTime: isZh.value
      ? "预计开业时间：26年8月"
      : "Estimated opening: August 2026",
  },
  {
    key: "genting",
    name: isZh.value ? "CABBEEN - 云顶世界" : "CABBEEN - Genting Highlands",
    type: "upcoming",
    lat: 3.42348,
    lng: 101.79325,
    address: "Genting Highlands, Pahang",
    mapQuery: "Genting Highlands Pahang",
    link: "https://maps.google.com/?q=Genting+Highlands+Pahang",
    reviewLink: "https://maps.google.com/?q=Genting+Highlands+Pahang",
    openingTime: isZh.value
      ? "预计开业时间：26年9月"
      : "Estimated opening: September 2026",
  },
  {
    key: "ioimall",
    name: "CABBEEN - IOI Mall",
    type: "upcoming",
    lat: 2.96944,
    lng: 101.7135,
    address: "IOI City Mall, Putrajaya",
    mapQuery: "IOI City Mall Putrajaya",
    link: "https://maps.google.com/?q=IOI+City+Mall+Putrajaya",
    reviewLink: "https://maps.google.com/?q=IOI+City+Mall+Putrajaya",
    openingTime: isZh.value
      ? "预计开业时间：26年10月"
      : "Estimated opening: October 2026",
  },
]);

const storeMap = computed(() => ({
  store1: {
    name: "CABBEEN卡宾 - Pavilion Bukit Jalil",
    type: "open",
    lat: 3.05125,
    lng: 101.67022,
    address:
      "Lot2.2100,Pavilion, Bukit Jalil, 57000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
    mapQuery: "CABBEEN Pavilion Bukit Jalil Kuala Lumpur",
    openTime: "10:00 - 22:00",
    phone: "+60 19-620 3028",
    email: "cabbeen.pvbj@ycinvest.com",
    Whatapp: "+60 19-620 3028",
    link: "https://maps.google.com/?q=CABBEEN,+Pavilion+Bukit+Jalil",
    reviewLink: "https://maps.google.com/?q=CABBEEN,+Pavilion+Bukit+Jalil",
    imageDir: "pvbj",
    socialLinks: commonSocialLinks,
  },
  store2: {
    name: "CABBEEN卡宾 - Sunway Velocity",
    type: "open",
    lat: 3.12806,
    lng: 101.72393,
    address:
      "LOT 2-46, SECOND FLOOR, SUNWAY VELOCITY MALL, Lingkaran SV, SUNWAY VELOCITY, 55100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur",
    mapQuery: "CABBEEN Sunway Velocity Mall Kuala Lumpur",
    openTime: "10:00 - 22:00",
    phone: "+60 19-620 3026",
    email: "cabbeen.velocity@ycinvest.com",
    Whatapp: "+60 19-620 3028",
    link: "https://maps.google.com/?q=CABBEEN卡宾+@+Sunway+Velocity",
    reviewLink: "https://maps.google.com/?q=CABBEEN卡宾+@+Sunway+Velocity",
    socialLinks: {
      facebook: "https://www.facebook.com/share/18r3T295sB/",
      tiktok:
        "https://www.tiktok.com/@cabbeen.sunway.ve?_t=ZS-8vx8u7JvMLI&_r=1",
      ig: "https://www.instagram.com/cabbeensunwayvelocity/",
    },
    imageDir: "sv",
  },
  store3: {
    name: "CABBEEN卡宾 - Mid Valley Megamall",
    type: "open",
    lat: 3.11891,
    lng: 101.67732,
    address:
      "F-037, First Floor, Mid Valley City, 59200 Wilayah Persekutuan, Wilayah Persekutuan Kuala Lumpur",
    mapQuery: "CABBEEN Mid Valley Megamall Kuala Lumpur",
    openTime: "10:00 - 22:00",
    phone: "010-376 2030",
    email: "cabbeen.midvalley@ycinvest.com",
    Whatapp: "010-376 2030",
    link: "https://maps.google.com/?q=CABBEEN+Mid+Valley+Megamall+Kuala+Lumpur",
    reviewLink: "https://maps.google.com/?q=CABBEEN+Mid+Valley+Megamall+Kuala+Lumpur",
    socialLinks: midValleySocialLinks,
  },
  store4: {
    name: isZh.value ? "即将开业" : "Opening Soon",
    type: "upcoming",
    lat: 3.14167,
    lng: 101.70036,
    address: "merdeak 118",
    mapQuery: "merdeak 118",
    link: "https://maps.google.com/?q=merdeak+118",
    reviewLink: "https://maps.google.com/?q=CABBEEN+Malaysia",
    socialLinks: upcomingSocialLinks,
  },
}));

const selectedKey = ref("store1");
const selectedUpcomingKey = ref("118mall");
const currentStore = computed(() => storeMap.value[selectedKey.value]);
const selectedUpcomingStore = computed(
  () =>
    upcomingStores.value.find((store) => store.key === selectedUpcomingKey.value) ||
    upcomingStores.value[0]
);
const mapTarget = computed(() =>
  currentStore.value.type === "upcoming"
    ? selectedUpcomingStore.value
    : currentStore.value
);
const mapEmbedUrl = computed(() => {
  const query = mapTarget.value.mapQuery || mapTarget.value.address || mapTarget.value.name;
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}&z=15&output=embed`;
});

const previewVisible = ref(false);
const previewImage = ref("");

function showImageDialog(imgSrc) {
  previewImage.value = imgSrc;
  previewVisible.value = true;
}

function closeImageDialog() {
  previewVisible.value = false;
}

const isMobile = ref(false);
const handleViewportResize = () => {
  isMobile.value = window.innerWidth < 768;
};

onMounted(() => {
  handleViewportResize();
  window.addEventListener("resize", handleViewportResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleViewportResize);
});

function switchStore(key) {
  selectedKey.value = key;
}

function switchUpcomingStore(key) {
  selectedKey.value = "store4";
  selectedUpcomingKey.value = key;
}

function goToMap() {
  window.open(mapTarget.value.link, "_blank");
}
</script>

<style scoped>
.store-map-page {
  padding: 50px 20px 50px 20px;
  background-color: #000000;
}

.store-selector {
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
}

.store-btn {
  color: #ffffff;
  border: 1px solid #ffffff88;
  background-color: transparent;
  padding: 8px 20px;
  font-weight: bold;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.store-btn:hover {
  border-color: #ffb100;
  background-color: #ffb10033;
  color: #ffb100;
}

.store-btn.active {
  background-color: #ffb100;
  color: #000000;
  border-color: #ffb100;
}

.main-content {
  display: flex;
  gap: 20px;
  flex-wrap: nowrap; /* ✅ 强制不换行 */
}

.map-box {
  flex: 0 0 65%;
  height: 500px;
  min-height: 300px;
  border-radius: 12px;
  position: relative;
}

.map-frame {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  border: 0;
  border-radius: 12px;
}

.info-box {
  flex: 0 0 35%;
  padding: 20px;
  color: #ffffff;
}

.info-box h2 {
  color: #ffffff;
  margin-top: 0;
}

.info-box p {
  margin: 10px 0;
  line-height: 1.6;
  color: #ffffff;
}

.info-actions {
  margin-top: 60px;
  text-align: center;
}

.upcoming-store-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
}

.upcoming-store-card {
  width: 100%;
  padding: 10px 16px;
  color: #ffffff;
  background-color: #000000;
  border: 1px solid #ffffff88;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

.upcoming-store-card strong,
.upcoming-store-card span {
  display: block;
}

.upcoming-store-card strong {
  font-size: 18px;
  line-height: 1.2;
}

.upcoming-store-card span {
  margin-top: 2px;
  font-size: 13px;
  line-height: 1.2;
}

.upcoming-store-card:hover,
.upcoming-store-card.active {
  background-color: #ffb100;
  border-color: #ffb100;
  color: #000000;
}

.go-btn {
  background-color: #ffb100;
  color: #000000;
  font-weight: bold;
  padding: 10px 24px;
  font-size: 16px;
  border-radius: 24px;
  box-shadow: 0 2px 8px rgba(241, 196, 15, 0.4);
  border: none;
  transition: all 0.3s ease;
}

.go-btn:hover {
  background-color: #ffd100;
  box-shadow: 0 4px 12px rgba(255, 209, 0, 0.6);
  transform: translateY(-1px);
}

.info-item {
  display: flex;
  align-items: center;
  margin: 12px 0;
  color: #ffffff;
}

.info-item .icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* 评价引导样式 */
.review-tip {
  margin: 8px 0 0;
  gap: 10px;
}
.review-text { color: #ffffff; opacity: 0.9; }
.review-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  margin-right: 6px;
}
.review-link {
  color: #ffb100;
  font-weight: 700;
  margin-left: 6px;
  text-decoration: underline;
}
.review-link:hover {
  color: #ffd100;
}

.social-icons {
  margin-top: 30px;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
}

.social-icons img {
  width: 30px;
  height: 30px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.social-icons img:hover {
  transform: scale(1.1);
}

/* ✅ 【新增】整体左右留白 */
.store-images {
  padding: 0 40px; /* 左右各留白40px */
}

/* ✅ 标题保持不变，仅作参考 */
.store-images .store-image-title {
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin: 40px 0 40px;
}

.yellow {
  color: #ffb100;
}

.store-images .image-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 40px;
  width: 100%;
}

/* ✅ 图片外框容器 */
.store-images .image-item {
  width: 100%;
  aspect-ratio: 4 / 3; /* 强制 4:3 比例 */
  overflow: hidden;
  border-radius: 8px;
  position: relative;
}

.store-images .store-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.3s ease; /* 添加过渡效果 */
  cursor: pointer; /* 可选：添加指针样式 */
}
.store-images .store-image:hover {
  transform: scale(1.05); /* 轻微放大5% */
}

/* 门店图片弹窗复用登录弹窗的遮罩和结构 */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.dialog.image-dialog {
  width: auto;
  max-width: 90vw;
  max-height: 90vh;
  background-color: #1a1a1a;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.8);
}

.dialog-body.image-dialog-body {
  padding: 0;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-body.image-dialog-body img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 0 0 12px 12px;
}

.dialog-header {
  padding: 16px 20px;
  background-color: #111;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.close-btn {
  cursor: pointer;
  font-size: 20px;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ffb100;
}
.store-images-mobile {
  padding: 0 16px;
  margin-bottom: 40px;
}

.swiper-slide {
  height: 220px; /* 你可以根据实际调整为240/260 */
}

.mobile-store-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.store-image-title {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: bold;
  margin: 30px 0 20px;
}

.store-image-title span {
  color: #ffb100;
}

.store-image-title::before {
  content: "门店实景";
  color: #ffffff;
}
/* 响应式支持 */
@media screen and (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .map-box,
  .info-box {
    min-width: 100%;
    width: 100%;
  }

  .map-box {
    height: 300px !important;
    order: -1;
  }

  .store-selector {
    flex-direction: column;
    align-items: stretch;
  }

  .store-btn {
    width: 100%;
    text-align: left;
    padding-left: 16px;
  }

  .info-box {
    padding: 16px;
    font-size: 15px;
  }

  .info-box p {
    font-size: 14px;
  }

  .info-box h2 {
    font-size: 18px;
  }

  /* 移动端弹窗样式优化 */
  .store-images .store-image:hover {
    transform: none; /* 移动端不再放大 */
  }

  .store-images .store-image {
    cursor: default;
  }
}
</style>
